<template>
  <div class="details-transactions">
    <div class="Fuell-Table Fuell-Table--transactions-card-detail">
      <div class="Fuell-Table--header">
        <div
          class="Fuell-Table--item Fuell-Table--sortable"
          @click="sortByField('isCompleted')"
        >
          <span v-t="{path: 'transactions_charged_table_header_status'}"></span>
          <span
            class="sortable-handler"
            :class="
              getSortableClass(isSortedByField('isCompleted'), sortDirection('isCompleted'))
            "
          ></span>
        </div>
        <div class="Fuell-Table--item"></div>
        <div
          @click="sortByField('date')"
          class="Fuell-Table--item Fuell-Table--sortable"
        >
          <span v-t="{ path: 'transactions_charged_table_header_date' }"></span>
          <span
            class="sortable-handler"
            :class="
              getSortableClass(isSortedByField('date'), sortDirection('date'))
            "
          ></span>
        </div>
        <div
          @click="sortByField('merchant')"
          class="Fuell-Table--item Fuell-Table--sortable"
        >
          <span v-t="{ path: 'transactions_charged_table_header_merchant' }"></span>
          <span
            class="sortable-handler"
            :class="
              getSortableClass(
                isSortedByField('merchant'),
                sortDirection('merchant')
              )
            "
          ></span>
        </div>
        <div
          @click="sortByField('amount')"
          class="Fuell-Table--item Fuell-Table--sortable"
        >
          <span v-t="{ path: 'transactions_charged_table_header_amount' }"></span>
          <span
            class="sortable-handler"
            :class="
              getSortableClass(
                isSortedByField('amount'),
                sortDirection('amount')
              )
            "
          ></span>
        </div>
      </div>

      <div class="Fuell-Table--content">
        <card-detail-transactions-table-row
          v-for="transaction in transactions"
          :columns="columns"
          :key="transaction.id"
          :transaction="transaction"
          @showTransactionDetail="showTransactionDetailModal"
        ></card-detail-transactions-table-row>
      </div>
    </div>
  </div>
</template>

<script>
import _tableSortingHandler from '@/components/Commons/_mixins/_tableSortingHandler'
import _sortableTableMixin from '@/components/Commons/_mixins/_sortableTableMixin'
import CardDetailTransactionsTableRow from './CardDetailTransactionsTableRow'

export default {
  name: 'CardDetailTransactions',
  components: { CardDetailTransactionsTableRow },
  mixins: [_tableSortingHandler, _sortableTableMixin],
  props: {
    cardId: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {

      columns: [
        {
          key: 'reviewStatus.code',
          visible: true,
          modifiable: false,
          template: 'minmax(96px, 120px'
        },
        {
          key: 'date',
          visible: true,
          modifiable: true,
          template: 'minmax(96px, 110px)'
        },
        {
          key: 'merchant',
          visible: true,
          modifiable: true,
          template: 'minmax(130px, 2fr)'
        },
        {
          key: 'amount',
          visible: true,
          modifiable: true,
          template: '120px'
        }
      ]
    }
  },
  computed: {
    currentFilters () {
      return this.$store.getters['TransactionsStore/filters']
    },
    tableGridTemplateStyle () {
      return {
        gridTemplateColumns: this.columns.map(c => c.template).join(' ')
      }
    },
    transactions () {
      return this.$store.getters['TransactionsStore/transactions'] || []
    }
  },
  methods: {
    sortByField (fieldName) {
      this.$store.dispatch('TransactionsStore/sortTransactionsByField', {
        fieldName
      })
    },
    showTransactionDetailModal (event) {
      this.$emit('showTransactionDetail', event)
    },
    async fetchTransactions () {
      const filters = {
        'card.id': this.cardId,
        'status.code': ['OK', 'PENDING'],
        'amountDistinctZero': true
      }
      try {
        await this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
          filters: filters
        })
      } catch (error) {
        this.$store.dispatch('TransactionsStore/addErrorHandler', { error: error, errorMessage: 'transactions_fetch_transactions_error' })
      }
    }
  },
  async created () {
    await this.fetchTransactions()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/card-transactions.scss";
</style>
<style>
.details-transactions {
  margin-top: 20px;
}
</style>
